export const SET_UI_DIALOG = 'SET_UI_DIALOG';
export const SET_UI_SEARCH = 'SET_UI_SEARCH';
export const SET_UI_SEARCH_KEYWORD = 'SET_UI_SEARCH_KEYWORD';
export const SET_UI_SEARCH_DRAWER_OPEN = 'SET_UI_SEARCH_DRAWER_OPEN';
export const SET_UI_SEARCH_DRAWER_OPEN_TOGGLE = 'SET_UI_SEARCH_DRAWER_OPEN_TOGGLE';
export const SET_UI_FULL_SCREEN_IMAGE_VIEWER = 'SET_UI_FULL_SCREEN_IMAGE_VIEWER';
export const SET_UI_FULL_SCREEN_IMAGE_VIEWER_INDEX = 'SET_UI_FULL_SCREEN_IMAGE_VIEWER_INDEX';
